<span style="font-size: .9rem;" *ngIf="booking?.planning" class="badge blue">Planning</span>
<!--<span  style="font-size: .9rem;" *ngIf="!booking?.planning" class="badge green">Booked</span>-->
